import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { styled } from "@mui/material";

import toast from "react-hot-toast";

import { Card, Button, Label } from "reactstrap";
import { coverUpload, tmpDelete } from "../../store/actions/tmpUpload";
import LinearUploader from "./LinearUploader";

const CoverUploader = (props) => {
	const { previewData, setPreviewData } = props;
	const dispatch = useDispatch();

	const { cover, coverIsUploading } = useSelector((state) => state.tmpUpload);

	useEffect(() => {
		return () => {
			// setPreviewData({ ...previewData, cover: "" });
			if (cover?.name) {
				dispatch(tmpDelete(cover.name, "cover"));
			}
		};
	}, []);
	useEffect(() => {
		if (cover.name) {
			setPreviewData({ ...previewData, cover: cover.name });
		}
	}, [cover]);

	const sizeLimit = 100 * 1024; // Limit for size upload file, Kb
	const allowedType = [
		"image/png",
		"image/jpg",
		"image/jpeg",
		// "image/gif",
		"image/webp",
	];

	const spacesURL = process.env.REACT_APP_API_DO_URL;
	const imageIpfsURL = process.env.REACT_APP_IPFS_HOST;

	const InputAsset = styled("input")({
		display: "none",
	});

	const cleanUpCover = () => {
		setPreviewData({ ...previewData, cover: "" });
		if (cover?.name) {
			dispatch(tmpDelete(cover.name, "cover"));
		}
	};

	const coverFileUpload = (event) => {
		let file = event.target.files[0];
		const fileSize = Math.round(file.size / 1024); // kilobyte

		if (!!file) {
			if (!allowedType.includes(file.type)) {
				return toast.error(`This file type is not supported`);
			}
			if (fileSize > sizeLimit) {
				return toast.error(
					`File size ${fileSize}Kb,  need no more ${Math.round(
						sizeLimit / 1024
					)}Mb`
				);
			} else {
				dispatch(coverUpload(file));
			}
		}
	};

	return (
		<>
			<Box className="form-label">
				<Typography
					component="p"
					sx={{
						fontFamily: "Montserrat",
						fontStyle: "normal",
						fontWeight: "normal",
						fontSize: "17px",
						lineHeight: "24px",
						"&:after": {
							color: "red",
							content: '"*"',
						},
					}}
				>
					Preview Image
				</Typography>
				<Typography
					sx={{
						fontFamily: "Montserrat",
						fontStyle: "normal",
						fontWeight: "normal",
						fontSize: "14px",
						lineHeight: "18px",
					}}
				>
					Because you’ve included multimedia, you’ll need to provide an image
					for the card display of your item.
				</Typography>
			</Box>
			<Card
				style={{
					position: "relative",
					display: "flex",
					justifyContent: "center",
					flexWrap: "wrap",
					width: "100%",
					borderRadius: "16px",
					padding: "2rem 3.5rem",
					margin: "2rem 0",
				}}
			>
				{(cover?.name || previewData.cover) && (
					<>
						<Button
							color="primary"
							style={{
								position: "absolute",
								top: "0.5rem",
								right: "0.5rem",
								width: "40px",
								minWidth: "40px",
								height: "40px",
								border: "1px solid #07ED63",
								borderRadius: "50%",
								color: "##040405",
							}}
							onClick={cleanUpCover}
						>
							x
						</Button>
						<Box
							sx={{
								width: "100%",
								height: "auto",
							}}
							component="img"
							src={
								cover?.name
									? `${spacesURL}/${cover.name}`
									: `${imageIpfsURL}/${previewData?.cover}`
							}
							alt="upload cover"
						/>
					</>
				)}

				{!cover?.name && !previewData.cover ? (
					<>
						<Typography
							mb="1rem"
							className="form-label"
							sx={{
								fontFamily: "Montserrat",
								width: "100%",
								textAlign: "center",
							}}
							component="div"
						>
							{coverIsUploading ? (
								<LinearUploader />
							) : (
								"PNG, JPG or WEBP. Max 100mb."
							)}
						</Typography>
						<Label
							for="input-cover"
							style={{
								textAlign: "center",
							}}
						>
							<InputAsset
								accept={"image/png, image/jpg, image/jpeg, image/webp"}
								id="input-cover"
								type="file"
								onChange={coverFileUpload}
							/>
							<Button
								color="primary"
								tag="span"
								variant="outlined"
								disabled={coverIsUploading}
							>
								Choose file
							</Button>
						</Label>
					</>
				) : null}
			</Card>
		</>
	);
};

export default CoverUploader;
